import React from 'react';
import { bool, func } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { sendCallMeBackRequest } from '../../ducks/callMeBack.duck';
import config from '../../config';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  SectionContactUs,
  SectionAboutHero,
  SectionAboutProofStats,
  SectionAboutOriginStory,
  SectionAboutHowItWorks,
  SectionAboutTrust,
  SectionAboutMarketplaceStats,
  SectionAboutTeam,
  SectionAboutStories,
  SectionAboutExplore,
} from '../../components';

import css from './AboutPage.module.css';
import snailImage from './images/snail.png';

const isFeatureEnabled = featureName => {
  return config.custom.featureToggles[config.env][featureName] === true;
};

export const AboutPageComponent = props => {
  const {
    intl,
    currentUser = null,
    onSubmitCallMeBack,
    submitInProgress,
    callMeBackError,
    callMeBackSuccess,
  } = props;
  const { siteTitle } = config;

  const schemaTitle = intl.formatMessage({ id: 'AboutPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage(
    { id: 'AboutPage.schemaDescription' },
    { siteTitle }
  );

  return (
    <StaticPage
      title={schemaTitle}
      description={schemaDescription}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: schemaDescription,
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn className={css.root}>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          <div className={css.heroContainer}>
            <SectionAboutHero className={css.hero} />
          </div>
          <SectionAboutProofStats />
          <ul className={css.sections}>
            <li className={css.section}>
              <div className={css.sectionContentFirstChild}>
                <SectionAboutOriginStory />
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionAboutHowItWorks />
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionAboutTrust />
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionAboutMarketplaceStats />
              </div>
            </li>
            {isFeatureEnabled('aboutTeam') && (
              <li className={css.section}>
                <div className={css.sectionContent}>
                  <SectionAboutTeam />
                </div>
              </li>
            )}
            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionAboutStories />
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionAboutExplore />
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionContactUs
                  onSubmitCallMeBack={onSubmitCallMeBack}
                  submitInProgress={submitInProgress}
                  callMeBackError={callMeBackError}
                  callMeBackSuccess={callMeBackSuccess}
                  currentUser={currentUser}
                  sectionTitle="Contact us"
                />
                <div className={css.contactUsContainer}>
                  <div className={css.contactUsContent}>
                    <img src={snailImage} alt="" className={css.contactImage} />
                    <p className={css.contactAddress}>
                      Contact us the old fashioned way at:
                      <br />
                      The Local Hire Group Pty Ltd
                      <br />
                      Level 8, 607 Bourke Street, Melbourne VIC 3000
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

AboutPageComponent.propTypes = {
  intl: intlShape.isRequired,
  currentUser: propTypes.currentUser,
  onSubmitCallMeBack: func.isRequired,
  submitInProgress: bool.isRequired,
  callMeBackError: propTypes.error,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { submitInProgress, callMeBackError, callMeBackSuccess } = state.callMeBack;

  return {
    currentUser,
    submitInProgress,
    callMeBackError,
    callMeBackSuccess,
  };
};

const mapDispatchToProps = dispatch => ({
  onSubmitCallMeBack: (name, phoneNumber, reasonForCallBack, otherInfo, email) =>
    dispatch(sendCallMeBackRequest(name, phoneNumber, reasonForCallBack, otherInfo, email)),
});

const AboutPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(AboutPageComponent);

export default AboutPage;
